import React from 'react';
import { Link } from 'react-router-dom';

import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';
import Lazy from '../../../../components/lazy';

import * as S from './styles';

type Props = {
  imageUrl?: string | null;
  pathName: string;
  preamble: string;
  title: string;
  linkText?: string;
};

const FeaturedArticle = ({
  imageUrl,
  pathName,
  preamble,
  title,
  linkText,
}: Props) => (
  <Panel header={<PanelHeader />}>
    <S.FeaturedArticle>
      {imageUrl && (
        <S.ImageWrapper>
          <Lazy loadOnIdle>
            <Link to={pathName}>
              <img src={imageUrl} alt="" />
            </Link>
          </Lazy>
        </S.ImageWrapper>
      )}
      <S.TextContainer>
        <h3>
          <Link to={pathName}>{title}</Link>
        </h3>

        <Link to={pathName}>
          <p>{preamble}</p>
        </Link>

        {linkText ? (
          <S.ArticleLink
            color="primary"
            variant="outlined"
            component={<Link to={pathName} />}
          >
            {linkText}
          </S.ArticleLink>
        ) : (
          []
        )}
      </S.TextContainer>
    </S.FeaturedArticle>
  </Panel>
);

export default FeaturedArticle;
